import { useEffect, useState } from 'react'
import usePermissions from './users'

export default function useRouteGuard(allowedPermissions: string[]) {
  const { permissions, isLoading } = usePermissions()
  const [hasAccess, setHasAccess] = useState<boolean | null>(null)

  useEffect(() => {
    if (permissions && permissions.role) {
      const userPermission = permissions.role

      // If user has no permissions or permissions not in allowed list
      if (!userPermission || !allowedPermissions.includes(userPermission)) {
        setHasAccess(false)
      } else {
        setHasAccess(true)
      }
    }
  }, [permissions, allowedPermissions])

  return { hasAccess, isLoading }
}
